<template id="step-challenge-cards">
    <ChallengeSectionContainer title="Sweepstakes Challenges"
                               tooltipText="Complete activities to earn entries into a grand prize drawing!"
                               v-bind:isBigContainer="isBigContainer"
                               v-bind:key="challengeList.length"
                               v-if="challengeList.length">
        <ChallengeCard v-for="challenge in challengeList"
                       v-bind:key="challenge.id"
                       class="sweepstakes-challenge"
                       v-bind:isBigContainer="isBigContainer"
                       v-bind:src="challenge.challenge_image"
                       v-bind:title="challenge.challenge_name"
                       v-bind:subtitle="getSubtitle(challenge)"
                       v-bind:type="getType(challenge)"
                       v-bind:potValue="getPotValue(challenge)"
                       v-bind:betValue="getBetValue(challenge)"
                       v-bind:teamSize="getTeamSize(challenge)"
                       v-bind:dateRange="dateRangeOf(challenge)"
                       v-bind:potTitle="'Grand Prize'"
                       v-bind:signUpUrl="challenge.challenge_landing_page" />
    </ChallengeSectionContainer>
</template>

<script>
import GeneralChallengeCards, { parsedPotValue } from './GeneralChallengeCards';
import ChallengeSectionContainer from './card/ChallengeSectionContainer';
import ChallengeCard from './card/ChallengeCard';

export default {
  template: '#step-challenge-cards',
  mixins: [GeneralChallengeCards],
  components: { ChallengeSectionContainer, ChallengeCard },
  data: function() {
    return {
      challengeType: 'sweepstakes'
    }
  },
  methods: {
    getPotValue: function(challenge) {
      return parsedPotValue(challenge.top_price_currency, challenge.top_price);
    }
  }
}
</script>
